export const frm_redirector = function(vue, api, VueScrollTo) {
    document.getElementById('app').arrive(".frm_message", async function() {
        var data = this.getElementsByTagName('p')[0].innerHTML;
        try {
            var obj = JSON.parse(data);
        } catch(e) {
            return;
        }
        if (obj && obj.redirect) {
            obj.redirect = obj.redirect.replace(/&amp;/g, '&');
            this.style.display = 'none';
            vue.loading = true;
            vue.item = await api.getUrl(obj.redirect, true);
            if (obj.message) {
                var message = '<div class="frm_style_formidable-style with_frm_style"><div class="frm_message"><p>' + obj.message + '</p></div></div>';
                vue.item.content.content.html = message + vue.item.content.content.html;
            }
            if (obj.reload && obj.reload == true) {
                vue.meta = await api.getMeta();
            }
            vue.loading = false;
            VueScrollTo.scrollTo("#app", 300, {
                offset: -20,
                onDone: function() {
                    VueScrollTo.scrollTo(".title-wrapper", 3000, {
                        offset: -40
                    });
                }
            });
        }
    });
}